/**
 * For an array of industry items ({ id, text, parentMetadataId, tier }),
 * prefixes any item whose text is "other" (case-insensitive) with its parent's text.
 * Falls back to the original text if no parent is found.
 *
 * @param {Array} displayItems - Items to display (typically filtered to tier 1 by caller)
 * @param {Array} allItems - Full array for parent lookup; defaults to displayItems
 */
export const prefixOtherIndustries = (displayItems, allItems = displayItems) => {
    if (!displayItems || displayItems.length === 0) return displayItems || [];
    return displayItems.map((item) => {
        if (item.text?.toLowerCase() === "other") {
            const parent = allItems.find((v) => v.id === item.parentMetadataId && v.id !== item.id);
            if (parent) {
                return { ...item, text: `${parent.text} / ${item.text}` };
            }
        }
        return item;
    });
};
